(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    const active = document.querySelector('[data-cc-end]');
    if (!active) return;

    const endTime = new Date(active.getAttribute('data-cc-end')).getTime();

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        const name = active.getAttribute('data-cc-name') || 'this athlete';
        const wrap = document.createElement('div');
        wrap.className = 'cc-banner__inner cc-banner__inner--expired';
        wrap.innerHTML =
          '<span class="cc-banner__icon" aria-hidden="true">⏳</span>' +
          '<div class="cc-banner__copy"><p class="cc-banner__title"></p></div>';
        wrap.querySelector('.cc-banner__title').textContent =
          'This collection is at risk of being archived, support ' + name + ' today to keep it alive!';
        active.replaceWith(wrap);
        return;
      }
      const days  = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins  = Math.floor((diff % 3600000) / 60000);
      const secs  = Math.floor((diff % 60000) / 1000);
      active.querySelector('[data-cc-days]').textContent  = pad(days);
      active.querySelector('[data-cc-hours]').textContent = pad(hours);
      active.querySelector('[data-cc-mins]').textContent  = pad(mins);
      active.querySelector('[data-cc-secs]').textContent  = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    const active = document.querySelector('[data-pc-end]');
    if (!active) return;

    const endTime = new Date(active.getAttribute('data-pc-end')).getTime();
    const display = active.querySelector('[data-pc-time]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        const name = active.getAttribute('data-pc-name') || 'this athlete';
        active.querySelector('.pc-bar__text').textContent =
          'This collection is at risk of being archived, support ' + name + ' today to keep it alive!';
        if (display) display.remove();
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      display.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
